<template>
  <el-main class="home-container" style="overflow: hidden">
    <LoginRegisterDialog ref="loginDialog" />
    
    <!-- 轮播图和功能按钮组合区域 -->
    <div class="carousel-function-wrapper">
      <!-- 左侧区域：军人职业发展横幅 + 轮播图 -->
      <div class="left-content">
        <!-- 军人职业发展图片区域 -->
        <div class="career-banner-container" @click="goToServicePlanning">
          <div class="career-banner-content">
            <div class="career-banner-text">
              <h2>一身戎装 不负韶华</h2>
              <span class="career-banner-subtitle">探索军校报考职业发展路径 开启军旅生涯新篇章</span>
            </div>
            <div class="career-banner-arrow">
              <span class="arrow-icon">→</span>
            </div>
          </div>
        </div>
        
        <!-- 轮播图 -->
        <div class="carousel-container">
        <!-- 加载状态显示 -->
        <div v-if="loading" class="loading">
          <el-icon class="loading-icon"><Loading /></el-icon>
          正在加载轮播图...
        </div>
        <!-- 轮播图内容 -->
        <el-carousel
          :height="carouselHeight"
          arrow="always"
          indicator-position="none"
          :autoplay="true"
          effect="fade"
        >
          <el-carousel-item
            v-for="(item, index) in carouselItems"
            :key="index"
          >
            <div class="carousel-content">
              <img :src="item.imgurl" alt="轮播图" class="carousel-image" />
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </div>
      
      <!-- 功能按钮区 -->
      <div class="function-buttons-container">
        <div class="function-buttons-wrapper">
          <div class="function-button" v-for="(btn, index) in functionButtons" :key="index" @click="goToPage(btn.router)">
            <div class="function-icon">{{ btn.icon }}</div>
            <span class="function-text">{{ btn.text }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 2026报考流程追踪 -->
    <div class="admission-process-wrapper">
      <div class="admission-process-container">
        <div class="admission-process-header">
          <h3 class="admission-process-title">2026 报考流程追踪</h3>
          <span class="admission-process-step">STEP {{ currentStep }}/{{ admissionSteps.length }}</span>
        </div>
        <div class="admission-process-steps">
          <div 
            v-for="(step, index) in admissionSteps" 
            :key="index"
            class="process-step-item"
            :class="{ active: currentStep === index + 1, completed: currentStep > index + 1 }"
          >
            <div class="step-number">{{ String(index + 1).padStart(2, '0') }}</div>
            <div class="step-name">{{ step.name }}</div>
            <div class="step-time">{{ formatDate(step.starttime) }} - {{ formatDate(step.endtime) }}</div>
            <div v-if="index < admissionSteps.length - 1" class="step-line"></div>
          </div>
        </div>
      </div>
   </div>
    
    <!-- 快捷功能入口 -->
    <div class="quick-entry-wrapper">
      <div class="quick-entry-container">
        <div class="quick-entry-buttons">
          <div 
            v-for="(btn, index) in quickEntryButtons" 
            :key="index"
            class="quick-entry-button"
            :class="`quick-entry-${btn.color}`"
            @click="goToPage(btn.router)"
          >
            <div class="quick-entry-icon">{{ btn.icon }}</div>
            <span class="quick-entry-text">{{ btn.text }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 军校报考资讯板块 -->
    <div class="full-width-bg military-news-bg">
      <div class="military-news-container">
        <div class="w">
          <div class="military-news-header">
            <h2 class="military-news-title">军校报考资讯</h2>
            <div class="military-news-tabs">
              <button 
                v-for="tab in newsTabs" 
                :key="tab.value"
                class="news-tab"
                :class="{ active: activeNewsTab === tab.value }"
                @click="switchNewsTab(tab.value)"
              >
                {{ tab.label }}
              </button>
              <span class="news-tab view-all" @click="goToNewsCenter">查看全部 ></span>
            </div>
          </div>
          
          <div class="military-news-content">
            <!-- 两列新闻列表 -->
            <div class="news-column">
              <div 
                v-for="news in displayNews.slice(0, 5)" 
                :key="news.id"
                class="news-item"
                @click="goToNewsDetail(news)"
              >
                <span class="news-title">{{ news.title }}</span>
                <span class="news-date">{{ news.publishTime || news.date || '-' }}</span>
              </div>
            </div>
            <div class="news-column">
              <div 
                v-for="news in displayNews.slice(5, 10)" 
                :key="news.id"
                class="news-item"
                @click="goToNewsDetail(news)"
              >
                <span class="news-title">{{ news.title }}</span>
                <span class="news-date">{{ news.publishTime || news.date || '-' }}</span>
              </div>
            </div>
            
            <!-- 空状态 -->
            <div v-if="displayNews.length === 0" class="empty-news">
              <p>暂无相关资讯</p>
              <el-button type="primary" @click="goToNewsCenter">查看更多资讯</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 军队院校专业指导老师 -->
    <div class="full-width-bg volunteer-planner-bg">
      <div class="w">
        <h2 class="main-title">凝聚军事院校专家心血，一对一精准规划建议</h2>
        <p class="subtitle">/ 全维度精准匹配你的强国梦 /</p>
        <div class="planner-cards">
          <div
            class="planner-card"
            v-for="(planner, index) in planners"
            :key="index"
          >
            <img
              :src="planner.imageUrl"
              :alt="planner.name"
              class="planner-image"
            />
            <div class="planner-info">
              <h3 class="planner-name">{{ planner.name }}</h3>
              <div class="planner-tags">
                <el-tag
                  v-for="tag in planner.tags"
                  :key="tag"
                  size="small"
                  effect="plain"
                  >{{ tag }}</el-tag
                >
              </div>
              <p class="planner-description">{{ planner.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import { ElMessage } from "element-plus";
import { baseURL } from "@/api/axiosConfig";
import {
  School,
  Notebook,
  Position,
  TrendCharts,
} from "@element-plus/icons-vue";
import { getCarouselList } from "@/api/carouselApi";
import { getNewsList } from "@/api/newsApi";
import { getTeacherList } from "@/api/teacherApi";
import { getAllProcess } from "@/api/processApi";
import { useAuthStore } from "@/store/authStore";
import LoginRegisterDialog from "@/components/LoginRegisterDialog.vue";
export default {
  components: {
    IconSchool: School,
    IconNotebook: Notebook,
    IconPosition: Position,
    IconTrendCharts: TrendCharts,
    LoginRegisterDialog
  },
  data() {
    return {
      // 轮播图相关
      carouselItems: [],
      loading: true,
      carouselHeight: '550px',
      isMobile: false,
      //新闻详情
      newsList: [],
      // 页面数据
      activeName: "all",
      planners: [],
      //科学规划
      cards: [
        {
          title: "测评优选",
          subtitle: "输入成绩、体检指标、政审情况,AI算法1秒生成适配院校清单。",
          image: require("@/assets/t1.png"),
          router: "/Test",
        },
        {
          title: "模拟填报",
          subtitle: "实时同步22所军队院校最新招生政策、专业目录、体检标准。",
          image: require("@/assets/t2.png"),
          router: "mocks",
        },
      ],
      // 功能按钮数据
      functionButtons: [
        { text: "志愿规划", router: "/volunteer-planning", icon: "📋" },
        { text: "AI面试模拟", router: "/ai-interview", icon: "🤖" },
        { text: "位次匹配", router: "/rank-query", icon: "📊" },
      ],
      // 快捷功能入口按钮数据
      quickEntryButtons: [
        { text: "专家答疑", router: "/expert-consultation", icon: "💬", color: "primary" },
        { text: "资讯中心", router: "/news-center", icon: "📰", color: "success" },
        { text: "女生报考", router: "/female-applicant", icon: "👩‍🎓", color: "pink" },
        { text: "体检标准", router: "/physical-standard", icon: "⚕️", color: "info" },
        { text: "政审指南", router: "/political-review", icon: "📋", color: "dark" },
      ],
      // 报考流程数据
      currentStep: 1,
      admissionSteps: [],
      //互动论坛数据
      newsList: [],
      // 军校报考资讯板块数据
      activeNewsTab: "all",
      newsTabs: [
        { label: "全部", value: "all" },
        { label: "热点资讯", value: "hot" },
        { label: "院校资讯", value: "school" },
        { label: "志愿填报", value: "volunteer" },
      ],
      newsLoading: true
    };
  },
  
  mounted() {
    this.fetchCarouselData(); //轮播图
    this.fetchNewsList(); // 新增：加载新闻列表
    this.fetchPlannerList(); // 教师数据
    this.fetchProcessData(); // 报考流程数据
    this.calculateCarouselHeight();
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  
  computed: {
    displayNews() {
      if (!this.newsList || this.newsList.length === 0) {
        return [];
      }
      
      if (this.activeNewsTab === 'all') {
        return this.newsList;
      }
      
      return this.newsList.filter(news => {
        const category = news.category || news.type;
        return category === this.activeNewsTab;
      });
    }
  },
  
  methods: {
    // 日期格式化
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 计算轮播图高度
    calculateCarouselHeight() {
      const width = window.innerWidth;
      // 扩大轮播图高度，使轮播图底部与右侧位次匹配按钮底部对齐
      if (width < 768) {
        this.carouselHeight = '220px';
      } else if (width < 1024) {
        this.carouselHeight = '260px';
      } else if (width < 1440) {
        this.carouselHeight = '300px';
      } else {
        this.carouselHeight = '340px';
      }
    },
    // 检测是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth < 320;
    },
    // 处理窗口大小变化
    handleResize() {
      this.calculateCarouselHeight();
      this.checkMobile();
    },
    // 轮播图点击处理
    handleCarouselClick(item) {
      if (item.routerPath) {
        this.$router.push(item.routerPath);
      }
    },
    
    // 跳转到军人职业发展页面
    goToServicePlanning() {
      this.$router.push('/service-planning');
    },

    // 报考流程数据获取
    async fetchProcessData() {
      try {
        const response = await getAllProcess();
        if (response.data.code === 200) {
          this.admissionSteps = response.data.data.processes;
          this.currentStep = response.data.data.currentStepIndex + 1;
        }
      } catch (error) {
        console.error("获取报考流程失败:", error);
      }
    },

    // 轮播图数据获取
    async fetchCarouselData() {
      getCarouselList().then((response) => {
        this.carouselItems = response.data.data;

        for (var i = 0; i < this.carouselItems.length; i++) {
          this.carouselItems[i].imgurl = baseURL + this.carouselItems[i].imgurl;
          switch (i) {
            case 0:
              this.carouselItems[i].routerPath = "/choose"; // 第一张图跳转到测评页
              break;
            case 1:
              this.carouselItems[i].routerPath = "/choose"; // 第二张图跳转到互动论坛
              break;
            default:
              this.carouselItems[i].routerPath = "/choose"; // 默认首页
          }
        }
        this.loading = false;
      });
    },
    //加载新闻列表
    async fetchNewsList() {
      try {
        const response = await getNewsList();

        if (response.data.code === 200) {
          // 确保数据存在且是数组
          if (response.data.data && Array.isArray(response.data.data.list)) {
            this.newsList = response.data.data.list.map((news, index) => ({
              id: news.id,
              title: news.title,
              content: news.content,
              publishTime: news.publishTime || news.date || news.createTime || news.updateTime || news.publish_time || news.create_time || '-',
              readingvolume: news.readingvolume,
              image: news.image,
              category: this.getCategoryByIndex(index),
            }));
          } else {
            this.newsList = [];
            console.warn("新闻数据格式不正确");
          }
        } else {
          this.$message.error("获取新闻失败：" + response.data.msg);
        }
      } catch (error) {
        console.error("获取新闻失败:", error);
      } finally {
        this.newsLoading = false;
      }
    },
    
    // 根据索引分配分类（模拟分类数据）
    getCategoryByIndex(index) {
      const categories = ['hot', 'hot', 'school', 'school', 'school', 'volunteer', 'volunteer', 'hot', 'school', 'volunteer', 'hot', 'school', 'volunteer', 'hot'];
      return categories[index % categories.length];
    },
    
    // 切换新闻标签
    switchNewsTab(tab) {
      this.activeNewsTab = tab;
      console.log('切换到:', tab);
    },
    
    // // 跳转到资讯中心
    // goToNewsCenter() {
    //   this.$router.push('/news');
    // },
    
    // 格式化日期，只显示月日
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${month}-${day}`;
    },
    
    // 去除HTML标签
    stripHtml(html) {
      if (!html) return "";
      const temp = document.createElement("div");
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || "";
    },
    //师资力量
    async fetchPlannerList() {
      try {
        const res = await getTeacherList();
        if (res.data.code === 200) {
          this.planners = res.data.data.map((teacher) => ({
            name: teacher.name,
            imageUrl: baseURL + teacher.imageurl,
            tags: ["军校报考", "升学规划"], // 可以从后端扩展字段或固定标签
            description: teacher.introduce,
          }));
        } else {
          this.$message.error("获取教师列表失败：" + res.data.msg);
        }
      } catch (error) {
        this.$message.error("请求失败：" + error.message);
      } finally {
        this.plannerLoading = false;
      }
    },
    // 路由跳转
    goToSchoolList() {
      this.$router.push({ name: "SchoolList" });
    },
    goToSubjectList() {
      this.$router.push({ name: "SubjectList" });
    },
    goToGrowthList() {
      this.$router.push({ name: "GrowthList" });
    },
    goToPage(route) {
      // 需要登录的页面列表
      const requireLoginRoutes = [
        '/volunteer-planning',
        '/ai-interview',
        '/expert-consultation',
        'mocks'
      ];
      
      // 检查是否需要登录
      if (requireLoginRoutes.includes(route)) {
        if (!this.isLoggedIn()) {
          this.$message.warning('请先登录，登录后才能使用该功能');
          this.openLoginDialog();
          return;
        }
      }
      this.$router.push(route);
    },
    // 打开登录弹窗
    openLoginDialog() {
      if (this.$refs.loginDialog && typeof this.$refs.loginDialog.openDialog === "function") {
        this.$refs.loginDialog.openDialog();
      }
    },
    // 检查用户是否已登录
    isLoggedIn() {
      const authData = localStorage.getItem('auth');
      if (!authData) return false;
      try {
        const storedAuth = JSON.parse(authData);
        const authState = storedAuth.state || storedAuth;
        return !!authState._token;
      } catch (e) {
        return false;
      }
    },
    // 跳转到资讯中心
    goToNewsCenter() {
      this.$router.push("/news-center");
    },
    // 跳转到资讯详情
    goToNewsDetail(news) {
      this.$router.push({ path: `/news-center/detail/${news.id}`, query: { from: 'home' } });
    },
    goToWinterCamp() {
      this.$router.push({ name: "WinterCamp" });
    },

    //互动论坛
    goToQuestions() {
      this.$router.push({ name: "Questions" });
    },
  },}
</script>
<style scoped>
/* 轮播图和功能按钮组合区域样式 */
/* 组合容器 */
.carousel-function-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 15px;
  padding: 0px 10px 10px 10px;
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  background-color: #F9F9F9;
}

/* 左侧区域：军人职业发展横幅 + 轮播图 */
.left-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 军人职业发展横幅 */
.career-banner-container {
  width: 100%;
  height: 120px;
  background: linear-gradient(135deg, #1a365d 0%, #2c5282 50%, #1a365d 100%);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.career-banner-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(44, 82, 130, 0.4);
}

.career-banner-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E');
  background-repeat: repeat;
}

.career-banner-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  max-width: 1200px;
}

.career-banner-text {
  display: flex;
  align-items: center;
  gap: 20px;
}

.career-banner-text h2 {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
}

.career-banner-subtitle {
  font-size: 25px;
  color: rgba(255, 255, 255, 0.85);
  flex: 1;
}

.career-banner-text p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}

.career-banner-arrow {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.career-banner-container:hover .career-banner-arrow {
  background: rgba(255, 255, 255, 0.25);
  transform: translateX(5px);
}

.arrow-icon {
  font-size: 24px;
  color: #fff;
  font-weight: bold;
}

/* 轮播图容器 */
.carousel-container {
  width: 100%;
  margin: 0;
  padding: 0;
}

/* 功能按钮容器 */
.function-buttons-container {
  width: 280px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

/* 功能按钮包装器 - 水平排列 */
.function-buttons-wrapper {
  display: flex;
  flex-direction: column;
  gap:25px;
  width: 100%;
  height: 100%;
}

.function-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  min-height: 100px;
  background: linear-gradient(135deg, #42a5f5 0%, #1e88e5 100%);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(66, 165, 245, 0.3);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  padding: 20px 25px;
  position: relative;
  overflow: hidden;
  animation: fadeInUp 0.6s ease-out forwards;
}

.function-button:nth-child(1) { animation-delay: 0.1s; opacity: 0; }
.function-button:nth-child(2) { animation-delay: 0.2s; opacity: 0; }
.function-button:nth-child(3) { animation-delay: 0.3s; opacity: 0; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.function-button:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 10px 25px rgba(66, 165, 245, 0.4);
}

.function-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.6s ease-out, height 0.6s ease-out;
}

.function-button:hover::before {
  width: 300px;
  height: 300px;
}

.function-icon {
  font-size: 44px;
  margin-right: 20px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.function-button:hover .function-icon {
  transform: scale(1.2) rotate(5deg);
}

.function-text {
  font-size: 20px;
  color: white;
  font-weight: 600;
  text-align: left;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
}

.function-button:hover .function-text {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* 响应式设计 */
@media (max-width: 1240px) {
  .w {
    width: 100%;
    padding: 0 20px;
  }
}

@media (max-width: 992px) {
  .carousel-function-wrapper {
    flex-direction: column;
  }
  
  .carousel-container {
    width: 100%;
  }
  
  .function-buttons-container {
    width: 100%;
  }
  
  .function-buttons-wrapper {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  
  .function-button {
    width: calc(33.33% - 10px);
    min-height: 100px;
  }
  
  .function-icon {
    font-size: 32px;
    margin-bottom: 8px;
    margin-right: 0;
  }
  
  .function-text {
    font-size: 14px;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .carousel-function-wrapper {
    padding: 0 15px;
    gap: 15px;
  }
  
  .function-buttons-wrapper {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 12px;
  }
  
  .function-button {
    width: calc(50% - 6px);
    min-height: 90px;
    padding: 12px;
  }
  
  .function-icon {
    font-size: 28px;
    margin-bottom: 6px;
    margin-right: 0;
  }
  
  .function-text {
    font-size: 13px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .carousel-function-wrapper {
    margin-top: 20px;
  }
  
  .function-button {
    min-height: 80px;
    padding: 10px;
  }
  
  .function-icon {
    font-size: 20px;
  }
  
  .function-text {
    font-size: 10px;
  }
}
</style>
<!-- 轮播图样式 -->
<style scoped>
/* 加载状态样式 */
.loading {
  text-align: center;
  padding: 50px;
  color: #666;
}

.loading-icon {
  font-size: 24px;
  margin-right: 10px;
  animation: rotate 2s linear infinite;
}



/* 无人机理论学习系统横幅样式 */
.drone-banner {
  background: linear-gradient(135deg, #0a192f 0%, #172a45 50%, #0a192f 100%);
  color: white;
  padding: 40px 0;
  margin: 40px 0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.drone-banner::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    rgba(76, 175, 80, 0) 0%,
    rgba(76, 175, 80, 0.1) 50%,
    rgba(76, 175, 80, 0) 100%
  );
  transform: rotate(45deg);
  animation: shine 3s infinite;
  z-index: 1;
}

@keyframes shine {
  0% {
    transform: rotate(45deg) translate(-100%, -100%);
  }
  100% {
    transform: rotate(45deg) translate(100%, 100%);
  }
}

.drone-banner:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 20px 40px rgba(76, 175, 80, 0.3);
}

.drone-banner-content {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
  position: relative;
  z-index: 2;
}

.drone-banner-icon {
  font-size: 64px;
  margin-right: 40px;
  color: #4caf50;
  animation: float 3s ease-in-out infinite;
  position: relative;
}

.drone-banner-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: rgba(76, 175, 80, 0.2);
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.8;
  }
}

.drone-banner-text {
  text-align: center;
  flex: 1;
  animation: fadeIn 1s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.drone-banner-text h3 {
  font-size: 28px;
  margin: 0 0 15px 0;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  animation: textGlow 2s ease-in-out infinite alternate;
}

@keyframes textGlow {
  from {
    text-shadow: 0 0 10px rgba(76, 175, 80, 0.5);
  }
  to {
    text-shadow: 0 0 20px rgba(76, 175, 80, 0.8), 0 0 30px rgba(76, 175, 80, 0.5);
  }
}

.drone-banner-text p {
  font-size: 18px;
  margin: 0;
  opacity: 0.9;
  font-weight: 500;
  animation: pulseText 2s ease-in-out infinite;
}

@keyframes pulseText {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.drone-banner-arrow {
  font-size: 32px;
  margin-left: 40px;
  color: #4caf50;
  animation: arrowMove 2s ease-in-out infinite;
  position: relative;
}

@keyframes arrowMove {
  0% {
    transform: translateX(0) scale(1);
  }
  50% {
    transform: translateX(15px) scale(1.1);
  }
  100% {
    transform: translateX(0) scale(1);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .drone-banner {
    padding: 30px 0;
  }
  
  .drone-banner-content {
    flex-direction: column;
    text-align: center;
  }
  
  .drone-banner-icon {
    font-size: 48px;
    margin-right: 0;
    margin-bottom: 20px;
  }
  
  .drone-banner-text h3 {
    font-size: 20px;
  }
  
  .drone-banner-text p {
    font-size: 16px;
  }
  
  .drone-banner-arrow {
    margin-left: 0;
    margin-top: 20px;
  }
}

/* 轮播图样式 */
.carousel-container {
  margin: 0;
  padding: 0;
}
.carousel-image {
  margin: 0; /* 移除外边距 */
  padding: 0; /* 移除内边距 */
  width: 100%; /* 确保宽度占满容器 */
  height: 100%; /* 确保高度占满容器 */
  object-fit: fill; /* 拉伸填充容器，不保持原图比例 */
}
.el-carousel {
  margin: 0; /* 移除外边距 */
  padding: 0; /* 移除内边距 */
  width: 100%; /* 确保宽度占满容器 */
}
.el-carousel__container {
  height: 100%; /* 确保高度一致 */
  margin: 0; /* 移除外边距 */
  padding: 0; /* 移除内边距 */
}
.carousel-content {
  margin-top: 0;
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-image {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .carousel-container {
    margin-top: 20px !important;
  }
  
  .el-carousel__arrow {
    font-size: 16px;
    width: 44px;
    height: 44px;
  }
  
  .el-carousel__indicators {
    bottom: 10px;
  }
  
  .el-carousel__button {
    width: 10px;
    height: 10px;
  }
  
  /* 确保卡片有足够的触摸区域 */
  .assessment-card,
  .planner-card {
    min-height: 44px;
  }
  
  /* 确保链接有足够的触摸区域 */
  a {
    min-height: 44px;
    display: inline-block;
  }
}
</style>
<style scoped>
/* 全宽背景容器 */
.z-index-up {
  position: relative;
  z-index: 2;
}
.background-image {
  background-image: url("@/assets/bg8.png");
  background-size: cover; /* 自适应容器
  background-position: center; /* 居中显示 */
  background-repeat: no-repeat; /* 不重复 */
}
.full-width-bg {
  padding: 60px 0; /* 上下内边距 */
  width: 100vw; /* 与屏幕一样宽 */
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  overflow: hidden;
  box-sizing: border-box;
}

/* 英雄区域样式 - 保持居中 */
.hero-section {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  color: black;
  padding: 0 20px; /* 添加左右内边距 */
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  color: rgb(73, 84, 96);
  font-size: 34px;
  font-weight: bold;
  margin-bottom: 20px;
  line-height: 1.4;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.hero-subtitle {
  font-size: 24px;
  margin-bottom: 10px;
  opacity: 0.9;
}

.hero-tagline {
  color: rgb(69, 135, 255);
  font-size: 18px;
  margin-bottom: 40px;
  font-style: italic;
  opacity: 0.8;
}
/* 动作按钮区域 */
.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

/* 按钮容器 - 白色背景 */
.button-wrapper {
  width: 280px;
  height: 65px;
  background-color: white; /* 白色背景 */
  border-radius: 50px; /* 圆润的边框 */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1); /* 添加轻微阴影增强立体感 */
  border: none; /* 移除边框 */
}

/* 按钮间距 */
.button-spacing {
  width: 60px; /* 60px间距 */
}

/* 文字按钮样式 - 深色文字 */
.text-button {
  width: 100%;
  height: 100%;
  color: #333 !important; /* 深灰色文字 */
  font-size: 24px !important;
  /* font-weight: bold !important; */
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

/* 悬停效果 - 轻微阴影变化 */
.button-wrapper:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15);
}
/* 查学校图标样式 */
.text-button i.fa {
  font-size: 18px;
  margin-right: 8px;
  color: #409eff;
  display: inline-block; /* 确保图标显示 */
}
/* 悬停效果 */
.button-wrapper:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15);
}
/* 查分数图标样式 */
.text-button i.fas {
  font-size: 18px;
  margin-right: 8px;
  display: inline-block;
}

/* 为查分数图标设置特定颜色 */
.text-button i.fa-chart-line {
  color: #4caf50; /* 绿色表示数据和分析 */
}

/* 为查院校图标设置特定颜色 */
.text-button i.fa-graduation-cap {
  color: #2196f3; /* 蓝色表示教育 */
}
/* 响应式设计 */
@media (max-width: 768px) {
  .hero-section {
    padding: 0 15px;
  }
  
  .hero-title {
    font-size: 24px;
    margin-bottom: 15px;
  }
  
  .hero-tagline {
    font-size: 16px;
    margin-bottom: 30px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 15px;
    margin-bottom: 30px;
  }

  .button-wrapper {
    width: 240px;
    height: 55px;
  }
  
  .text-button {
    font-size: 20px !important;
  }

  .button-spacing {
    width: 0;
    height: 15px;
  }

  /* 确保在小屏幕上图标仍然显示 */
  .text-button i.fa,
  .text-button i.fas {
    font-size: 16px;
    margin-right: 6px;
  }
  
  /* 确保在小屏幕上按钮有足够的触摸区域 */
  .button-wrapper {
    min-height: 55px;
  }
  
  .text-button {
    min-height: 55px;
  }
}
</style>

<style scoped>
/* 基础容器 */
.w {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  overflow-x: hidden;
  box-sizing: border-box;
}
.assessment-bg-container {
  /* background-image: url("@/assets/bg7.png"); */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 16px;

  padding: 30px 0;
  margin-top: -50px;
  position: relative;
  z-index: 1;
}
.assessment-bg-container .w {
  padding-top: 50px;
}
/* 卡片容器布局 - 保持水平排列 */
.card-container {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  width: 100%;
}

/* 卡片尺寸调整 - 左右布局 */
.assessment-card {
  width: calc(50% - 15px); /* 保持两个卡片水平排列 */
  height: 180px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* 添加浅蓝色渐变背景 */
  background: linear-gradient(135deg, #e6f0ff, #cfe2ff);
  border: 1px solid #b8d4ff;
}

/* 卡片内容布局 - 图片左侧，文字右侧 */
.card-content {
  display: flex; /* 水平布局 */
  width: 100%;
  height: 100%;
}

/* 图片样式 - 左侧 */
.card-image {
  width: 130px;
  height: 179px;
  object-fit: cover;
  transition: transform 0.3s ease;
  object-position: center;
  max-width: 100%;
}

/* 文字区域 - 右侧 */
.card-text {
  width: 60%; /* 文字占据60%宽度 */
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* 文字样式调整 */
.card-title {
  font-size: 28px;
  margin-bottom: 12px;
  margin-top: 0;
  color: rgb(73, 84, 96);
}

.card-subtitle {
  font-size: 18px;
  line-height: 1.6;
  margin-top: 0;
  color: rgb(61, 128, 180); /* 蓝色文字 */
}
/* 悬停效果增强 */
.assessment-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(30, 87, 230, 0.2);

  /* 悬停时背景变化 */
  background: linear-gradient(135deg, #d7e7ff, #c0d9ff);
}

.assessment-card:hover .card-image {
  transform: scale(1.05);
}

/* 添加装饰线条 */
.card-text::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 40%; /* 与图片宽度对齐 */
  background: linear-gradient(
    45deg,
    transparent,
    transparent 10px,
    rgba(30, 87, 230, 0.1) 10px,
    rgba(30, 87, 230, 0.1) 20px
  );
  background-size: 20px 20px;
  z-index: -1;
  opacity: 0.5;
}

/* 移动端适配 */
@media (max-width: 1240px) {
  .w {
    width: 100%;
    padding: 0 20px;
  }
  
  .assessment-bg-container .w {
    padding-top: 30px;
  }
}

@media (max-width: 992px) {
  .card-container {
    gap: 20px;
  }

  .assessment-card {
    height: 200px;
  }

  .card-text {
    padding: 15px;
  }

  .card-title {
    font-size: 22px;
  }
  
  .card-subtitle {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .assessment-bg-container {
    padding: 20px 0;
    margin-top: -50px;
  }
  
  .assessment-bg-container .w {
    padding-top: 20px;
  }
  
  .card-container {
    flex-direction: column;
    gap: 20px;
  }

  .assessment-card {
    width: 100%;
    height: auto;
  }

  .card-content {
    flex-direction: column;
  }

  .card-image {
    width: 100%;
    height: 180px;
    border-right: none;
    border-bottom: 1px solid #d1e4ff;
  }

  .card-text {
    width: 100%;
    padding: 15px;
  }

  .card-title {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .card-subtitle {
    font-size: 14px;
  }

  /* 移动端移除装饰线条 */
  .card-text::before {
    display: none;
  }
}

@media (max-width: 480px) {
  .assessment-bg-container {
    margin-top: -30px;
  }
  
  .card-image {
    height: 150px;
  }
  
  .card-title {
    font-size: 18px;
  }
  
  .card-subtitle {
    font-size: 13px;
  }
}
</style>
<!-- 高考规划师 -->
<style scoped>
/* 整体容器 */
.volunteer-planner-bg {
  background-color: #F9F9F9;
  border-radius: 16px;
  margin-top: 0;
  padding: 10px 10px 10px 10px;
  text-align: center;
  overflow: hidden;
}
/* .volunteer-planner-container {
  margin: 50px auto;
  text-align: center;
  background: linear-gradient(135deg, #e6f0ff, #cfe2ff);
  border-radius: 16px;
  padding: 40px 20px;
  box-shadow: 0 6px 20px rgba(30, 87, 230, 0.15);
  border: 1px solid #b8d4ff;
} */

/* 主标题样式 */
.main-title {
  color: rgb(73, 84, 96);
  font-size: 34px;
  font-weight: bold;
  margin-bottom: 20px;
  line-height: 1.4;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* 副标题样式 */
.subtitle {
  /* font-size: 24px;
  color: #4a6fc9;
  margin-bottom: 40px;
  font-style: italic;
  position: relative;
  display: inline-block;
  padding: 0 20px; */
  color: rgb(69, 135, 255);
  font-size: 18px;
  margin-bottom: 40px;
  font-style: italic;
  opacity: 0.8;
}

.subtitle::before {
  left: 0;
}

.subtitle::after {
  right: 0;
}
.section-title {
  text-align: right;
  font-size: 20px;
  margin-bottom: 10px;
}

.planner-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 0 10px 10px 10px;
  box-sizing: border-box;
}

.planner-card {
  width: 32%;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.planner-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.planner-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.planner-info {
  padding: 20px;
}

.planner-name {
  font-size: 18px;
  margin-bottom: 10px;
}

.planner-tags {
  margin-bottom: 10px;
}

.planner-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
  white-space: pre-line;
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.planner-card .el-button {
  width: 100%;
  min-height: 44px;
}
/* 在项目的全局或组件样式文件中添加 */
.home-container.el-main {
  position: static !important; /* 覆盖 position: relative */
  padding: 0 !important; /* 覆盖 --el-main-padding */
}

/* 确保军人职业发展横幅在导航栏下方正确显示 */
.career-banner-wrapper {
  position: relative;
  z-index: 10;
  margin-top: 10px;
}

/* 响应式设计 */
@media (max-width: 1240px) {
  .w {
    width: 100%;
    padding: 0 20px;
  }
}

@media (max-width: 1024px) {
  .main-title {
    font-size: 28px;
    padding: 0 20px;
  }
  
  .subtitle {
    font-size: 16px;
    margin-bottom: 30px;
    padding: 0 20px;
  }
  
  .planner-card {
    width: calc(50% - 10px);
  }
  
  .planner-name {
    font-size: 16px;
  }
  
  .planner-description {
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .volunteer-planner-bg {
    padding: 30px 0;
  }
  
  .main-title {
    font-size: 24px;
    padding: 0 15px;
    margin-bottom: 15px;
  }
  
  .subtitle {
    font-size: 14px;
    margin-bottom: 20px;
    padding: 0 15px;
  }
  
  .planner-cards {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .planner-card {
    width: 90%;
    margin-bottom: 0;
  }
  
  .planner-info {
    padding: 15px;
  }
  
  .planner-image {
    height: 180px;
  }
  
  .planner-name {
    font-size: 16px;
  }
  
  .planner-description {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .volunteer-planner-bg {
    padding: 20px 0;
  }
  
  .main-title {
    font-size: 20px;
  }
  
  .subtitle {
    font-size: 12px;
  }
  
  .planner-card {
    width: 95%;
  }
  
  .planner-image {
    height: 150px;
  }
  
  .planner-info {
    padding: 12px;
  }
  
  .planner-name {
    font-size: 14px;
  }
  
  .planner-description {
    font-size: 12px;
  }
  
  .planner-card .el-button {
    min-height: 40px;
    font-size: 14px;
  }
}
</style>

<style scoped>
/* 无人机理论学习系统横幅 */
.drone-banner {
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  padding: 20px 30px;
  background: linear-gradient(135deg, #1a5f7a 0%, #159895 100%);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(22, 160, 133, 0.3);
}

.drone-banner:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(22, 160, 133, 0.4);
}

.drone-banner-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.drone-banner-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.drone-banner-icon i {
  font-size: 24px;
  color: #fff;
}

.drone-banner-text {
  text-align: center;
}

.drone-banner-text h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 2px;
}

.drone-banner-text p {
  margin: 5px 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.drone-banner-arrow {
  font-size: 20px;
  color: #fff;
  opacity: 0.8;
}

.loading-indicator,
.error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 15px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1001;
}

/* 响应式字体大小 */
@media (max-width: 768px) {
  .loading-indicator,
  .error-message {
    font-size: 12px;
    padding: 8px 12px;
  }
  
  .loading {
    font-size: 14px;
    padding: 30px;
  }
  
  .loading-icon {
    font-size: 20px;
  }
  
  /* 调整标签字体大小 */
  .el-tag {
    font-size: 12px;
    padding: 2px 8px;
  }
}

@media (max-width: 480px) {
  .loading {
    font-size: 12px;
    padding: 20px;
  }
  
  .loading-icon {
    font-size: 16px;
  }
  
  /* 调整标签字体大小 */
  .el-tag {
    font-size: 11px;
    padding: 1px 6px;
  }
}

.loading-indicator {
  background-color: rgba(59, 130, 246, 0.9);
  color: white;
}

.error-message {
  background-color: rgba(239, 68, 68, 0.9);
  color: white;
}

@media (max-width: 1024px) {
  .fixed-left-image {
    display: none;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .home-page {
    padding: 10px;
  }
  
  .header {
    padding: 0 12px;
  }
  
  .header-content {
    height: 60px;
  }
  
  .logo {
    font-size: 18px;
  }
  
  .logo span {
    font-size: 12px;
  }
  
  .nav-menu {
    display: none;
  }
  
  .user-info {
    margin-left: 10px;
  }
  
  .user-avatar {
    width: 32px;
    height: 32px;
  }
  
  .user-name {
    display: none;
  }
  
  .banner {
    height: 200px;
  }
  
  .banner-content {
    padding: 0 20px;
  }
  
  .banner h1 {
    font-size: 24px;
  }
  
  .banner p {
    font-size: 14px;
  }
  
  .btn-primary {
    padding: 10px 20px;
    font-size: 14px;
  }
  
  .content-section {
    padding: 30px 0;
  }
  
  .section-title {
    font-size: 22px;
  }
  
  .section-subtitle {
    font-size: 14px;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .feature-card {
    padding: 20px;
  }
  
  .feature-icon {
    font-size: 40px;
    width: 80px;
    height: 80px;
  }
  
  .feature-title {
    font-size: 16px;
  }
  
  .feature-desc {
    font-size: 14px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
  
  .stat-card {
    padding: 20px;
  }
  
  .stat-value {
    font-size: 28px;
  }
  
  .stat-label {
    font-size: 13px;
  }
  
  .news-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .news-card {
    padding: 20px;
  }
  
  .news-title {
    font-size: 16px;
  }
  
  .news-date {
    font-size: 12px;
  }
  
  .news-content {
    font-size: 14px;
  }
  
  .footer {
    padding: 30px 20px;
  }
  
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .footer-info {
    margin-bottom: 20px;
  }
  
  .footer-links {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
  
  .quick-links {
    flex-direction: column;
    gap: 10px;
  }
  
  .login-modal-content {
    width: 90%;
    max-width: 320px;
    padding: 20px;
  }
  
  .login-modal h2 {
    font-size: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-control {
    padding: 10px 15px;
  }
  
  .btn {
    padding: 10px 20px;
  }
  
  .register-link {
    font-size: 13px;
  }
}

/* 快捷功能入口模块样式 */
.quick-entry-wrapper {
  padding: 10px 10px;
  background-color: #F9F9F9;
}

.quick-entry-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 10px 20px;
  border-radius: 12px;
  background: #ffffff;
}

.quick-entry-header {
  text-align: center;
  margin-bottom: 30px;
}

.quick-entry-title {
  font-size: 28px;
  font-weight: bold;
  color: #334155;
  margin: 0;
}

.quick-entry-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.quick-entry-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 24px 20px;
  width: 100%;
  height: auto;
  border-radius: 12px;
  cursor: pointer;
  border: 1px solid transparent;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.quick-entry-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.quick-entry-button:active {
  transform: scale(0.98);
}

.quick-entry-icon {
  font-size: 32px;
  margin-right: 16px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.quick-entry-button:hover .quick-entry-icon {
  transform: scale(1.1);
}

.quick-entry-text {
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  transition: all 0.3s ease;
  color: #333;
}

.quick-entry-button:hover .quick-entry-text {
  color: inherit;
}

/* 按钮背景色 */
.quick-entry-primary {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border-color: #a5d6a7;
}

.quick-entry-primary:hover {
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
}

.quick-entry-success {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-color: #90caf9;
}

.quick-entry-success:hover {
  background: linear-gradient(135deg, #bbdefb 0%, #90caf9 100%);
}

.quick-entry-pink {
  background: linear-gradient(135deg, #fce4ec 0%, #f8bbd9 100%);
  border-color: #f48fb1;
}

.quick-entry-pink:hover {
  background: linear-gradient(135deg, #f8bbd9 0%, #f48fb1 100%);
}

.quick-entry-info {
  background: linear-gradient(135deg, #e0f7fa 0%, #b2ebf2 100%);
  border-color: #80deea;
}

.quick-entry-info:hover {
  background: linear-gradient(135deg, #b2ebf2 0%, #80deea 100%);
}

.quick-entry-dark {
  background: linear-gradient(135deg, #eceff1 0%, #cfd8dc 100%);
  border-color: #b0bec5;
}

.quick-entry-dark:hover {
  background: linear-gradient(135deg, #cfd8dc 0%, #b0bec5 100%);
}



/* 响应式设计 */
@media (max-width: 992px) {
  .quick-entry-wrapper {
    padding: 30px 0;
  }
  
  .quick-entry-title {
    font-size: 24px;
  }
  
  .quick-entry-buttons {
    gap: 15px;
  }
  
  .quick-entry-button {
    padding: 14px 16px;
  }
  
  .quick-entry-icon {
    font-size: 28px;
    margin-right: 12px;
  }
  
  .quick-entry-text {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .quick-entry-container {
    padding: 0 15px;
  }
  
  .quick-entry-buttons {
    gap: 12px;
    flex-wrap: wrap;
  }
  
  .quick-entry-button {
    width: calc(50% - 6px);
    padding: 12px 14px;
    min-width: 140px;
  }
  
  .quick-entry-icon {
    font-size: 24px;
    margin-right: 10px;
  }
  
  .quick-entry-text {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .quick-entry-wrapper {
    padding: 20px 0;
  }
  
  .quick-entry-title {
    font-size: 20px;
  }
  
  .quick-entry-buttons {
    gap: 10px;
  }
  
  .quick-entry-button {
    width: calc(50% - 5px);
    padding: 10px 12px;
    min-width: 120px;
  }
  
  .quick-entry-icon {
    font-size: 22px;
    margin-right: 8px;
  }
  
  .quick-entry-text {
    font-size: 12px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .home-page {
    padding: 0 15px;
  }
  
  .header-content {
    max-width: 100%;
  }
  
  .nav-menu {
    gap: 15px;
  }
  
  .nav-item {
    font-size: 14px;
  }
  
  .banner {
    height: 300px;
  }
  
  .banner h1 {
    font-size: 32px;
  }
  
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .news-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .footer-info {
    margin-bottom: 20px;
  }
  
  .footer-links {
    justify-content: center;
  }
}

@media (min-width: 1025px) and (max-width: 1440px) {
  .header-content {
    max-width: 1200px;
  }
  
  .main-content {
    max-width: 1200px;
  }
  
  .footer-content {
    max-width: 1200px;
  }
}

@media (min-width: 1441px) {
  .header-content {
    max-width: 1440px;
  }
  
  .main-content {
    max-width: 1440px;
  }
  
  .footer-content {
    max-width: 1440px;
  }
}

/* 报考流程追踪样式 */
.admission-process-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 10px 10px 0px 10px;
  box-sizing: border-box;
  background: #F9F9F9;
}

.admission-process-container {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px  10px 10px  10px;
  /* box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08); */
}

.admission-process-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;

}

.admission-process-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.admission-process-step {
  font-size: 14px;
  color: #2e7d32;
  font-weight: 600;
  margin-right: 60px;
}

.admission-process-steps {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.process-step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
}

.step-number {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #e8e8e8;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.process-step-item.active .step-number {
  background: #2e7d32;
  color: #fff;
}

.process-step-item.completed .step-number {
  background: #4caf50;
  color: #fff;
}

.step-name {
  font-size: 13px;
  color: #666;
  text-align: center;
  white-space: nowrap;
}

.step-time {
  font-size: 11px;
  color: #999;
  text-align: center;
  margin-top: 4px;
}

.process-step-item.active .step-name {
  color: #2e7d32;
  font-weight: 600;
}

.step-line {
  position: absolute;
  top: 22px;
  left: 60%;
  width: 80%;
  height: 2px;
  background: #e0e0e0;
  z-index: 0;
}

.process-step-item.completed .step-line {
  background: #4caf50;
}

/* 军校报考资讯板块样式 */
.military-news-bg {
  background: #fff;
 
  padding:  10px 10px 0px 10px;
  overflow: hidden;
  box-sizing: border-box;
}

.military-news-container {
  background-color: #F9F9F9;
  border-radius: 12px;
  /* padding: 20px; */
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
}

.military-news-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 10px 0 10px;
}

.military-news-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.military-news-tabs {
  display: flex;
  gap: 25px;
  align-items: center;
  margin-right: 40px;
}

.news-tab {
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px 16px;
  border-radius: 20px;
  background: transparent;
  border: none;
  outline: none;
}

.news-tab:hover {
  color: #1e90ff;
  background: rgba(30, 144, 255, 0.1);
  transform: translateY(-1px);
}

.news-tab.active {
  color: #fff;
  font-weight: 500;
  background: linear-gradient(135deg, #1e90ff 0%, #00bfff 100%);
  box-shadow: 0 4px 15px rgba(30, 144, 255, 0.3);
}

.news-tab:active {
  transform: scale(0.95);
}

.news-tab.view-all {
  color: #1e90ff;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid #1e90ff;
  transition: all 0.3s ease;
}

.news-tab.view-all:hover {
  color: #fff;
  background: #1e90ff;
}

.empty-news {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #999;
}

.empty-news p {
  margin-bottom: 20px;
  font-size: 16px;
}

.military-news-subtitle {
  font-size: 14px;
  color: #999;
  margin-bottom: 25px;
  padding: 0 10px;
  margin-top: 0;
}

.military-news-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px 20px 0;
}

.military-news-title {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.military-news-content {
  display: flex;
  gap: 20px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 20px;
  background: #fff;
  border-radius: 8px;
  margin-top: 0;
}

/* 新闻列 */
.news-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.news-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px dashed #eee;
}

.news-item:last-child {
  border-bottom: none;
}

.news-item:hover {
  background: #f8f9fa;
  padding-left: 8px;
}

.news-title {
  flex: 1;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 15px;
}

.news-item:hover .news-title {
  color: #1e90ff;
}

.news-date {
  font-size: 12px;
  color: #999;
  flex-shrink: 0;
  min-width: 80px;
  text-align: right;
  padding-left: 10px;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .military-news-bg {
    padding: 30px 10px;
  }
  
  .military-news-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .military-news-title {
    font-size: 20px;
  }
  
  .military-news-tabs {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .news-tab {
    font-size: 13px;
  }
  
  .military-news-content {
    flex-direction: column;
    gap: 15px;
  }
  
  .news-item {
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .news-date {
    flex-basis: 100%;
  }
}
</style>